<template>
  <div
    class="trade-countdown"
    :style="{ width: `${Math.floor((value / 90) * 100)}%` }"
  >
    <strong>{{ value }}s</strong>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "TradeCountdown",
  data() {
    return {
      value: 90,
      setIntervalData: null,
    };
  },

  computed: { ...mapGetters(["getWC"]) },

  methods: {
    ...mapMutations(["CHANGE_USER_INFO", "SET_CONNECT_TYPE"]),
    ...mapActions(["logoutConnectWallet"]),
  },

  mounted() {
    this.setIntervalData = setInterval(async () => {
      this.value = this.value - 1;

      if (this.value == 0) {
        clearInterval(this.setIntervalData);
        this.$notify.error({
          title: "Connection Timed Out",
          message: "Rescan code to login again",
          showClose: true,
          duration: 5000,
        });
        this.logoutConnectWallet();
        // await this.getWC.disconnect();
        // this.CHANGE_USER_INFO(null);
        // this.SET_CONNECT_TYPE("");
        this.$emit("close");
      }
    }, 1000);
  },
  destroyed() {
    clearInterval(this.setIntervalData);
  },
};
</script>
<style lang="scss" scoped>
.trade-countdown {
  pointer-events: none;
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  box-sizing: border-box;
  background-image: linear-gradient(
    90deg,
    rgb(24 238 216 / 30%) 1%,
    rgb(166 246 22 / 30%) 100%
  );
  transition: width 1s ease-in;

  animation: borderRadiusCountdown 90s ease-in;

  strong {
    padding: 24px 24px 32px;
    display: block;
  }
}

@keyframes borderRadiusCountdown {
  5% {
    border-radius: 20px 200px 200px 20px;
  }
}
</style>
